import { __awaiter, __generator } from "tslib";
import { Text } from '@wix/design-system';
import classnames from 'classnames';
import React, { useCallback, useEffect, useState, } from 'react';
import { DATA_HOOKS } from '../../../dataHooks';
import { getTopOffsetForScrollToArticlePage } from '../../../utils/scroll';
import { ConsumerSource } from '../../../types';
export var ScrollSpy = function (_a) {
    var steps = _a.steps, consumerSource = _a.consumerSource, onClick = _a.onClick, containerRef = _a.containerRef;
    var _b = useState(steps.length > 0 ? steps[0].id : ''), activeStepId = _b[0], setActiveStepId = _b[1];
    var onScroll = useCallback(function () {
        var container = containerRef === null || containerRef === void 0 ? void 0 : containerRef.current;
        var isContainerScroll = container !== undefined;
        if (isContainerScroll && container && consumerSource === ConsumerSource.HELP_CENTER) {
            var isAtBottom = Math.abs(container.scrollHeight - container.clientHeight - container.scrollTop) < 5;
            if (isAtBottom && steps.length > 0) {
                setActiveStepId(steps[steps.length - 1].id);
                return;
            }
        }
        for (var i = 0; i < steps.length; i++) {
            var stepElement = document === null || document === void 0 ? void 0 : document.getElementById(steps[i].id);
            if (!stepElement)
                continue;
            var scrollPosition = void 0;
            var elementPosition = void 0;
            if (isContainerScroll) {
                scrollPosition = container.scrollTop;
                var containerRect = container.getBoundingClientRect();
                var stepRect = stepElement.getBoundingClientRect();
                elementPosition = stepRect.top - containerRect.top + container.scrollTop;
            }
            else {
                scrollPosition = window.scrollY + getTopOffsetForScrollToArticlePage();
                elementPosition = stepElement.offsetTop;
            }
            if (scrollPosition >= elementPosition - 10) {
                if (i === steps.length - 1) {
                    setActiveStepId(steps[i].id);
                    return;
                }
                else {
                    var nextStepElement = document === null || document === void 0 ? void 0 : document.getElementById(steps[i + 1].id);
                    if (nextStepElement) {
                        var nextElementPosition = void 0;
                        if (isContainerScroll) {
                            var containerRect = container.getBoundingClientRect();
                            var nextStepRect = nextStepElement.getBoundingClientRect();
                            nextElementPosition = nextStepRect.top - containerRect.top + container.scrollTop;
                        }
                        else {
                            nextElementPosition = nextStepElement.offsetTop;
                        }
                        if (scrollPosition <= nextElementPosition - 10) {
                            setActiveStepId(steps[i].id);
                            return;
                        }
                    }
                }
            }
        }
    }, [steps, containerRef]);
    useEffect(function () {
        var container = containerRef === null || containerRef === void 0 ? void 0 : containerRef.current;
        var scrollElement = container || window;
        scrollElement === null || scrollElement === void 0 ? void 0 : scrollElement.addEventListener('scroll', onScroll);
        return function () {
            scrollElement === null || scrollElement === void 0 ? void 0 : scrollElement.removeEventListener('scroll', onScroll);
        };
    }, [onScroll, containerRef]);
    var onClickStep = function (step, order) { return __awaiter(void 0, void 0, void 0, function () {
        var id, text;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    id = step.id, text = step.text;
                    return [4 /*yield*/, onClick(id, text, order)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement("ul", { className: "stepsWrapper ".concat(consumerSource) },
        React.createElement("div", { className: 'stepsLine' }),
        steps.map(function (step, index) { return (React.createElement("li", { key: step.id, tabIndex: 0, "aria-label": step.text, className: classnames("level-".concat(step.level), "anchor-".concat(index)), onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, onClickStep(step, "".concat(index + 1))];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            }); }, onKeyDown: function (e) { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!(e.key === 'Enter')) return [3 /*break*/, 2];
                            return [4 /*yield*/, onClickStep(step, "".concat(index + 1))];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            }); } },
            React.createElement("div", null,
                React.createElement("span", { className: classnames('stepBullet', {
                        activeStepBullet: activeStepId === step.id,
                    }) },
                    React.createElement("span", { className: "activeIndicator" })),
                index === steps.length - 1 ? (React.createElement("span", { className: "lastStepClear" })) : null,
                React.createElement(Text, { size: 'small', dataHook: "".concat(DATA_HOOKS.SCROLL_SPY_ANCHOR, "-").concat(index + 1), className: classnames({
                        stepLinkTextActive: activeStepId === step.id,
                        stepLinkText: activeStepId !== step.id,
                    }) }, step.text)))); })));
};
//# sourceMappingURL=index.js.map